import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../../dispatcher/AdminAppDispatcher';
import AdminConstants from '../../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'QUOTE_SEARCH_CHANGE';

let searchResults = [];
const QuoteSearchStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
  clearSearchResults() {
    searchResults = [];
    this.emitChange();
  },
  getSearchResults() {
    return searchResults;
  },
  setSearchResults(results) {
    searchResults = results;
  },
});

QuoteSearchStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
  const action = payload.action;
  switch (action.type) {
    case ActionTypes.SEARCH_QUOTES_SUCCESS:
      QuoteSearchStore.setSearchResults(action.quotes);
      QuoteSearchStore.emitChange();
      break;
    default:
      break;
  }
});

export default QuoteSearchStore;
